import styles from './object-page-section.module.scss';
import { type ReactNode } from 'react';

const ObjectPageSection = ({ children, title }: IProps) => {
	return (
		<section className={styles.wrapper}>
			<h2 className={styles.header}>{title}</h2>
			<div className={styles.content}>{children}</div>
		</section>
	);
};

export interface IProps {
	title: string;
	children: ReactNode;
}

export default ObjectPageSection;
